
const lang = {
  page_title: '林分収穫表',
  breadcrumb: {
    list: '林分収穫表',
    detail: '林分収穫表詳細',
  },
  button: {
    document_output: '書類の出力',
    upload: 'アップロード',
    read_start: '読込開始',
  },
  select_prefecture: {
    prefecture: '都道府県',
    default_text: '全国',
  },
  table: {
    position1: '地位Ⅰ',
    position2: '地位Ⅱ',
    position3: '地位Ⅲ',
    position4: '地位Ⅳ',
    position5: '地位Ⅴ',
    position6: '地位Ⅵ',
    position7: '地位Ⅶ',
    position8: '地位Ⅷ',
    position9: '地位Ⅸ',
    position10: '地位Ⅹ',
  },
}

export default lang
